import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 's-form-row',
  templateUrl: './s-form-row.component.html',
  styleUrls: ['./s-form-row.component.scss'],
  standalone: true
})
export class SFormRowComponent {
  @HostBinding('class.shrink') shrinkCss = true;
}
